import { useState, useEffect, useContext } from "react"
import { FirebaseContext } from "../firebase"
import { UserContext } from "../context/userContext"

export default function use2FAPending() {
  const [isPending2FA, setIsPending2FA] = useState(false)
  const firebase = useContext(FirebaseContext)
  const userCtx = useContext(UserContext)

  useEffect(() => {
    const { staff_id } = userCtx.session.user
    const userConfigRef = firebase.db.collection("user-config").doc(staff_id)

    const unsubscribe = userConfigRef.onSnapshot(
      (snapshot) => {
        const staffData = snapshot.data()?.staff || {}
        setIsPending2FA(
          staffData.multifactor?.required && !staffData.multifactor?.configured
        )
      },
      (error) => {
        console.error("Error fetching user config snapshot:", error)
      }
    )

    return () => unsubscribe()
  }, [firebase.db, userCtx.session.user])

  return isPending2FA
}
